import type { ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import MinesGame from '@/components/games/mines-game'
import { GameHeader } from '@/components/games/game-ui'
import { GAMES } from '@/constants/site'

const game = GAMES[3]

const MinesPage = (): ReactNode => {
    return (
        <>
            <Seo title='Mines' description='Find diamonds and dodge the TNT on a 5×5 board. Every safe tile raises your multiplier.' />
            <GameHeader title={game.name} subtitle={game.subtitle} />
            <MinesGame />
        </>
    )
}

export default MinesPage
